import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ResultpageService } from '../../../../share/service/resultpage.service';
import {
  OffersOfApplication,
  SortOptions,
} from '../../../../share/type/result_type';
import { BehaviorSubject, Subscription, combineLatest } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NavigationService } from '../../../../share/service/navigation.service';

@Component({
  selector: 'app-main-filter',
  templateUrl: './main-filter.component.html',
  styleUrls: ['./main-filter.component.scss'],
})
export class MainFilterComponent implements OnInit {
  @Input() filterData!: any;
  @Input() filterOptionsData!: any;
  @Input() offersData!: OffersOfApplication[];
  @Input() filterOverlay!: boolean;
  @Output() filterOutput = new EventEmitter<string>();
  @Input() eternalPage!: boolean;
  @Input() resultPage!: boolean;

  public sortingOption!: SortOptions;
  private overlaySubscription: Subscription;
  private filterSubscription: Subscription;
  private postSubscription: Subscription;

  private postData$ = new BehaviorSubject(1);
  private filterState = [];

  //---create array for filter layout---
  public filter = [
    {
      title: 'Max. monatliche Rate',
      key: 'monthlyRate',
      type: 'barplot',
      data: [],
      checked: 0,
    },
    {
      title: 'Kreditsumme',
      key: 'loanAmount',
      type: 'checkbox',
      data: [],
    },
    {
      title: 'Laufzeit',
      key: 'creditDuration',
      type: 'checkbox',
      data: [],
    },
    {
      title: 'Kreditschutz',
      key: 'creditProtection',
      type: 'checkbox',
      data: [],
      hint: [
        {
          title: 'Basisschutz',
          text: 'Schutz im Todesfall',
        },
        {
          title: 'Standardschutz',
          text: 'Schutz bei Tod & Arbeitsunfähigkeit',
        },
        {
          title: 'Komplettschutz',
          text: 'Schutz bei Tod, Arbeitsunfähigkeit & Arbeitslosigkeit',
        },
      ],
    },
    {
      title: 'Flexible Rückzahlung',
      key: 'flexibleRepayment',
      type: 'checkbox',
      data: [],
      hint: [],
    },
    {
      title: 'Online Abschluss',
      key: 'onlineContract',
      type: 'radio',
      data: [],
      hint: [
        {
          title: 'Online Abschluss',
          text: 'Bei Krediten mit Online Abschluss können Sie Ihre Unterschrift schnell und einfach digital setzen. Ganz ohne Post und Papierkram. ',
        },
      ],
    },
    {
      title: 'Benötigte Nachweise',
      key: 'docsRequired',
      type: 'radio',
      data: [],
      hint: [
        {
          title: 'Keine Nachweise nötig',
          text: 'Mit der Option "keine Nachweise" können Sie Ihren Kredit schnell und einfach abschließen, ohne weitere Dokumente an die Bank zu schicken. ',
        },
      ],
    },
    {
      title: 'Auszahlung',
      key: 'payout',
      type: 'radio',
      data: [],
    },
    {
      title: 'Zinsart',
      key: 'interestTypes',
      type: 'radio',
      data: [],
      hint: [
        {
          title: 'Zinsart',
          text: 'Fixe Zinsen bleiben über die im Vorfeld festgelegte Kreditlaufzeit gleich, während sich variable Zinsen in der Regel mehrfach ändern.',
        },
      ],
    },
  ];
  //---create array for filter layout---

  //---create object for array for filter layout---
  private offerRequeste = {
    title: 'Anfragezeitpunkt',
    key: 'offerRequestedAt',
    type: 'checkbox',
    data: [],
  };
  //---create object for array for filter layout---

  constructor(
    private resultpageService: ResultpageService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.debouncePostDataSend();

    let options$ = this.resultpageService.filerOptionsDataObserv$;
    let filterState$ = this.resultpageService.filterStateDataObserv$;
    let sorting$ = this.resultpageService.optionSortingObserv$;

    const dataObserv$ = combineLatest({
      item1: options$,
      item2: filterState$,
      item3: sorting$,
    });

    if (this.eternalPage) {
      this.filter.unshift(this.offerRequeste);
    }

    this.filterSubscription = dataObserv$.subscribe((data) => {
      this.filterOptionsData = data.item1;
      if (data.item2 !== 1) {
        this.filterState = data.item2 ? data.item2 : [];
      }
      if (
        data.item3 !== 1 &&
        this.filterOptionsData &&
        this.filterOptionsData.sorting
      ) {
        this.sortingOption = data.item3;
      } else {
        this.sortingOption = { name: 'Relevanz', value: 'RELEVANCE' };
      }
      this.improveFilterData();
    });

    this.overlaySubscription = this.resultpageService.overlayObserv$.subscribe(
      (overlay) => (this.filterOverlay = overlay)
    );
  }

  ngOnDestroy() {
    this.filterSubscription.unsubscribe();
    this.postSubscription.unsubscribe();
    this.overlaySubscription.unsubscribe();
  }

  openFilter(): void {
    const filter = document.getElementById('filter') as HTMLElement;
    filter.classList.toggle('openFilter');
  }

  openSorting(): void {
    const sorting = document.getElementById('sorting') as HTMLElement;
    sorting.classList.add('openSorting');
  }

  improveFilterData(): void {
    this.filter.forEach((el) => {
      //---check if we have the same object than we add its data---
      if (this.filterOptionsData && this.filterOptionsData !== 1) {
        if (this.filterOptionsData.hasOwnProperty(el.key)) {
          el.data = this.filterOptionsData[el.key];
        } else {
          return;
        }
      } else {
        el.data = [];
      }
      //---check if we have the same object than we add its data---
      //---for input range we improve value---
      if (el.type == 'barplot') {
        el.checked =
          this.filterOptionsData && this.filterOptionsData.monthlyRateMax
            ? this.filterOptionsData.monthlyRateMax
            : 0;
        if (el.data.length === 0) {
          el.data = [{ value: 0 }, { value: 1 }];
        }
        el['oneAmount'] = el.data.length === 1;
        el['amountMin'] = el.data[0].value;
        el['amountMax'] = el.data[el.data.length - 1].value;
        el['disabled'] =
          (el.data[0].value == 0 && el.data[1].value == 1) ?? el['oneAmount'];
        //---check state of filter, if this element exists than we use its value---
        if (this.filterState) {
          let checkElement = this.filterState.find(
            (elem) => elem.key == el.key
          );
          if (checkElement) {
            el['checked'] = checkElement.value;
          }
        } else {
          el['checked'] =
            this.filterOptionsData && this.filterOptionsData !== 1
              ? this.filterOptionsData.monthlyRateMax
              : 0;
        }
        //---check state of filter, if this element exists than we use its value---
        el['selectRangeProgress'] =
          el['checked'] !== 0 && !el['oneAmount']
            ? ((el['checked'] - el['amountMin']) * 100) /
              (el['amountMax'] - el['amountMin'])
            : 0;
        el.data.forEach((obj) => {
          obj.position =
            ((obj.value - el['amountMin']) * 100) /
            (el['amountMax'] - el['amountMin']);
        });
      }
      //---for input range we improve value---

      //---for checkbox we improve value---
      if (el.type == 'checkbox') {
        if (el.data.length == 0 && el.key == 'offerRequestedAt') {
          el.data = [{ value: 0 }, { value: 0 }, { value: 0 }];
        }
        if (el.data.length == 0 && el.key == 'loanAmount') {
          el.data = [{ value: 0 }, { value: 0 }, { value: 0 }];
        }
        if (el.data.length == 0 && el.key == 'creditDuration') {
          el.data = [{ value: 0 }, { value: 0 }, { value: 0 }];
        }
        if (el.key != 'flexibleRepayment') {
          el.data.map((obj: any) => {
            switch (true) {
              case el.key == 'loanAmount':
                let value = obj.value.toLocaleString('de-DE', {
                  minimumFractionDigits: 0,
                });
                obj['name'] = value + ' €';
                break;
              case el.key == 'creditDuration':
                obj['name'] = obj.value + ' Monate';
                break;
              case el.key == 'offerRequestedAt':
                obj['name'] = obj.value;
                break;
            }
            //---check state of filter, if this element exists than we use its value---
            if (this.filterState) {
              let checkElement = this.filterState.some(
                (elem) => elem.key == el.key
              );
              if (checkElement) {
                let checkValue = this.filterState.some(
                  (elem) => elem.value == obj.value
                );
                obj['checked'] = checkValue;
              } else {
                obj['checked'] = false;
              }
            } else {
              obj['checked'] = false;
            }
            //---check state of filter, if this element exists than we use its value---
          });
        } else {
          let newDataArr = [];
          let newHintArr = [];
          for (const property in el.data) {
            el.data[property].map((propObj) => {
              let hintObj = {};
              hintObj['title'] = propObj.name;
              hintObj['text'] = propObj.hint;
              propObj.type = property;
              //---check state of filter, if this element exists than we use its value---
              if (this.filterState) {
                let checkElement = this.filterState.some(
                  (elem) => elem.key == el.key
                );
                if (checkElement) {
                  let checkValue = this.filterState.some(
                    (elem) => elem.value == propObj.value
                  );
                  propObj['checked'] = checkValue;
                } else {
                  propObj['checked'] = false;
                }
              } else {
                propObj['checked'] = false;
              }
              //---check state of filter, if this element exists than we use its value---
              newDataArr.push(propObj);
              newHintArr.push(hintObj);
            });
          }
          el.data = newDataArr;
          el.hint = newHintArr;
        }
      }
      //---for checkbox we improve value---

      //---for radio button we add min rate on the page and add button's name---
      if (
        el.type == 'radio' &&
        Object.keys(this.filterOptionsData).length > 1
      ) {
        if (el.key === 'interestTypes') {
          const options = this.filterOptionsData['interestTypes']
            .filter((option: string) => option !== 'FIXED_AND_VARIABLE')
            .map((option: string) => {
              return {
                value: option,
                label:
                  option === 'FIXED'
                    ? 'fix'
                    : option === 'VARIABLE'
                    ? 'variabel'
                    : option,
              };
            })
            .sort(
              (
                a: { label: string; value: string },
                b: { label: string; value: string }
              ) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())
            );

          el.data = [{ label: 'egal', value: 'DEFAULT' }, ...options];
          const interestState = this.filterState?.find(
            (elem: { key: string }) => elem.key === 'interestTypes',
          );
          el['interestTypesRadioData'] = {
            value: interestState ? interestState.value : 'DEFAULT',
          };
        } else {
          let rate: any = this.filter.find((obj) => obj.key === 'monthlyRate');
          let obj: any = {};
          if (this.filterState) {
            let checkElement = this.filterState.find(
              (elem) => elem.key == el.key
            );
            obj['value'] = checkElement
              ? checkElement.value
              : this.filterOptionsData[el.key][0];
          } else {
            obj['value'] = this.filterOptionsData[el.key][0];
          }
          obj['minRate'] = rate.data[0]
            ? rate.data[0].value.toLocaleString('de-DE', {
                minimumFractionDigits: 0,
              })
            : 0;
          switch (true) {
            case el.key == 'onlineContract':
              obj['name'] = 'Online Abschluss';
              break;
            case el.key == 'docsRequired':
              obj['name'] = 'keine Nachweise';
              break;
            case el.key == 'payout':
              obj['name'] = 'morgen';
              break;
          }
          el.data = obj;
        }
      }
      //---for radio button we add min rate on the page and add button's name---
    });
  }

  postFilter(obj: any, box: string): void {
    switch (box) {
      case 'checkbox':
        if (obj.checked) {
          if (obj.type) {
            if (
              this.filterData[obj.key] &&
              this.filterData[obj.key][obj.type]
            ) {
              this.filterData[obj.key][obj.type] =
                this.filterData[obj.key][obj.type];
            } else {
              this.filterData[obj.key] = this.filterData[obj.key]
                ? this.filterData[obj.key]
                : {};
              this.filterData[obj.key][obj.type] = this.filterData[obj.key][
                obj.type
              ]
                ? this.filterData[obj.key][obj.type]
                : [];
            }
            this.filterData[obj.key][obj.type] = [
              ...this.filterData[obj.key][obj.type],
              { value: obj.value },
            ];
          } else {
            this.filterData[obj.key] = this.filterData[obj.key]
              ? this.filterData[obj.key]
              : [];
            this.filterData[obj.key] = [
              ...this.filterData[obj.key],
              { value: obj.value },
            ];
          }
          //---save info for filter state---
          this.filterState = [...this.filterState, obj];
          //---save info for filter state---
        } else {
          if (obj.type) {
            if (
              this.filterData[obj.key] &&
              this.filterData[obj.key][obj.type]
            ) {
              this.filterData[obj.key][obj.type] = this.filterData[obj.key][
                obj.type
              ].filter(function (el: any) {
                return el.value != obj.value;
              });
            }
          } else {
            this.filterData[obj.key] = this.filterData[obj.key].filter(
              function (el: any) {
                return el.value != obj.value;
              }
            );
          }
          //---save info for filter state---
          this.filterState = this.filterState.filter(function (el: any) {
            return el.value != obj.value;
          });
          //---save info for filter state---
        }

        break;
      case 'radio':
        if (obj.key === 'interestTypes' && obj.value[0] === 'DEFAULT') {
          this.filterData[obj.key] = undefined;
        } else {
          this.filterData[obj.key] = obj.value;
        }
        //---save info for filter state---
        let checkRadioElement = this.filterState.some(
          (el) => el.key == obj.key
        );
        if (checkRadioElement) {
          this.filterState.find((el) => {
            if (el.key == obj.key) {
              el.value = obj.value[0];
            }
          });
        } else {
          obj.value = obj.value[0];
          this.filterState = [...this.filterState, obj];
        }
        //---save info for filter state---
        break;
      case 'range':
        this.filterData[obj.key] = [{ value: obj.value }];
        //---save info for filter state---
        let checkRangeElement = this.filterState.some(
          (el) => el.key == obj.key
        );
        if (checkRangeElement) {
          this.filterState.find((el) => {
            if (el.key == obj.key) {
              el.value = obj.value;
            }
          });
        } else {
          this.filterState = [...this.filterState, obj];
        }
        //---save info for filter state---
        this.filter.find((el) => {
          if (el.key == 'monthlyRate') {
            el['selectRange'] = obj.value;
          }
        });
        break;
      case 'reset':
        this.filterData = {};
        this.filterState = [];
        break;
    }
    this.postData$.next(this.filterData);
    //---updating filter data for post request---
    this.resultpageService.updatedStateFilerData(this.filterState);
    //---updating filter data for post request---
  }

  debouncePostDataSend(): void {
    this.postSubscription = this.postData$
      .pipe(debounceTime(500))
      .subscribe((e) => {
        if (e !== 1) {
          //---show overlay on filter and chips until data load---
          this.filterOverlay = true;
          this.resultpageService.updatedOverlay(this.filterOverlay);
          //---show overlay on filter and chips until data load---

          //---updating filter data for post request---
          this.resultpageService.updatedFilerDataPost(e);
          //---updating filter data for post request---

          //---create pos request in parent component---
          this.filterOutput.emit();
          //---create pos request in parent component---
        }
      });
  }

  skipToOffers(): void {
    this.navigationService.skipToMainContent();
  }

  trackByFilterOption(index: number, option: { key?: string }): string {
    return option?.key ?? `${index}`;
  }

  trackByCheckboxOption(
    index: number,
    checkbox: { value?: string | number; type?: string }
  ): string {
    return `${checkbox?.value ?? ''}-${checkbox?.type ?? ''}-${index}`;
  }
}
